// Module
var code = `<div class="likelihood-switch" data-toggle="tooltip" title="Likelihood to switch jobs"> <div class="percent" ng-class="{'full': predictionScoreCtrl.isFullPercentClass}"> {{predictionScoreCtrl.formattedPredictionScore}} </div> <div class="right-arrow"></div> <div class="{{'yellow-circle ' + predictionScoreCtrl.circleClass}}"> </div> </div> `;
// Exports
export default code;